import React, { ReactElement, forwardRef, useImperativeHandle } from 'react';
import { KImage } from '@/component/RtlLayout';

import { StyleSheet } from 'react-native';

type IProps = {
    imageSrc: any;
    styleObj?: any;
};
const ArrowRight = forwardRef(function specLine(props: IProps, ref): ReactElement {
    const { imageSrc, styleObj } = props;

    const styles = StyleSheet.create({
        myImage: {
            width: 16,
            height: 16,
            ...styleObj,
        },
    });

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useImperativeHandle(
        ref,
        () => {
            return {
                // 暴露出去的方法,
            };
        },
        []
    );
    return <KImage style={styles.myImage} source={imageSrc} />;
});
export default ArrowRight;
